import { Link } from "react-router-dom";

/**
 * Public-facing footer reused on Landing + Status + Privacy + Terms + Support
 * pages. Compact, premium ivory background, IRA-aligned wording (not regulated
 * — pending approval). Mobile-friendly tap targets (min-h-11).
 */
export default function PublicFooter() {
  return (
    <footer
      data-testid="public-footer"
      className="px-6 lg:px-10 max-w-7xl mx-auto py-8 border-t border-[#114232]/10 text-xs text-[#5c6360] flex flex-wrap items-center justify-between gap-3"
    >
      <div className="font-mono" data-testid="footer-tagline">
        © {new Date().getFullYear()} Nyoksure · Built for IRA Kenya regulatory alignment
      </div>
      <nav
        className="flex gap-2 sm:gap-4 flex-wrap"
        aria-label="Footer navigation"
      >
        <Link
          to="/status"
          className="min-h-11 inline-flex items-center px-2 hover:text-[#114232] focus:text-[#114232] focus:outline-none focus:underline transition-colors"
          data-testid="footer-link-status"
        >
          Status
        </Link>
        <Link
          to="/privacy"
          className="min-h-11 inline-flex items-center px-2 hover:text-[#114232] focus:text-[#114232] focus:outline-none focus:underline transition-colors"
          data-testid="footer-link-privacy"
        >
          Privacy
        </Link>
        <Link
          to="/terms"
          className="min-h-11 inline-flex items-center px-2 hover:text-[#114232] focus:text-[#114232] focus:outline-none focus:underline transition-colors"
          data-testid="footer-link-terms"
        >
          Terms
        </Link>
        <Link
          to="/support"
          className="min-h-11 inline-flex items-center px-2 hover:text-[#114232] focus:text-[#114232] focus:outline-none focus:underline transition-colors"
          data-testid="footer-link-support"
        >
          Support
        </Link>
      </nav>
    </footer>
  );
}
